import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/location_new/chicago/fast_back.webp";
import { Link } from "gatsby";

function Richhouston() {
  return (
    <section
      className="rich_houston fast_chicago"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <h2>Fast-Track Time-to-Market with TekRevol</h2>
            <p>
              Get your high-fidelity MVP with agile mobile app development
              services in Chicago.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
               Launch Your Mobile App
            </Link>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="mt-auto">
            <div className="fast_track_img">
              <StaticImage
                src="../../images/location_new/chicago/fast_track.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={649}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Richhouston;
